export default __webpack_public_path__ + "static/media/01.3fa6fff1.png";